var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRemainBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#DE3530",
    width: 44,
    height: 44,
    rx: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10h24v24H10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19h19a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H13a1 1 0 0 1-1-1V19zm1-6h15v4H12v-3a1 1 0 0 1 1-1zm12 11v2h3v-2h-3z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemainBalance);
export default __webpack_public_path__ + "static/media/remain-balance.de69c5334702a017c1765215b1ca1e59.svg";
export { ForwardRef as ReactComponent };